import { HttpMethod } from '@previo/core'
import { APIPaths } from '~/http/APIPaths'
import Http from '~/http/Http'
import type { AccountAssignments } from '~/http/invoicing/accountAssignments/types'

export class AccountAssignmentsAPI extends Http {
  getAccountAssignments = (): Promise<AccountAssignments> => {
    return this.callAuthWithPropertyAPI<null, AccountAssignments>(
      HttpMethod.GET,
      {
        path: APIPaths.INVOICING_ACCOUNT_ASSIGNMENTS,
      },
      null,
    )
  }
}
